/* GlamourGallery — mobile menu drawer footer fine-links.
 * Sentinel: gg-menu-finelinks-v1
 *
 * Mirrors the gg-footer bottom-bar fine-links (Start a return /
 * Returns policy / Contact) into the mobile menu drawer so phone
 * users can reach them without scrolling the page footer. Only
 * runs at narrow viewports — the desktop footer already exposes
 * these links inline.
 */
(function () {
  'use strict';

  var INJECT_ID = 'gg-menu-finelinks';
  // Match the CSS — fine-links should appear at every viewport
  // where the drawer is the only menu. CSS hides inline nav at
  // ≤1366px OR on touch devices regardless of width; mirror that.
  var MQ_NARROW = '(max-width: 1366px), (hover: none) and (pointer: coarse)';

  var LINKS = [
    { href: '/pages/start-return',  label: 'Start a return' },
    { href: '/pages/returns',       label: 'Returns policy' },
    { href: 'mailto:hello@glamourgallery.co.uk', label: 'Contact' },
  ];

  function buildHTML() {
    var inner = LINKS.map(function (l, i) {
      return (
        (i > 0 ? '<span class="gg-menu-finelinks__sep" aria-hidden="true">·</span>' : '') +
        '<a class="gg-menu-finelinks__link" href="' + l.href + '">' + l.label + '</a>'
      );
    }).join('');
    return (
      '<nav id="' + INJECT_ID + '" class="gg-menu-finelinks" aria-label="Help and policies">' +
        inner +
      '</nav>'
    );
  }

  function isNarrow() {
    return !!(window.matchMedia && window.matchMedia(MQ_NARROW).matches);
  }

  function inject() {
    if (!isNarrow()) return;
    var drawer = document.querySelector('.menu-drawer');
    if (!drawer) return;
    if (drawer.querySelector('#' + INJECT_ID)) return;

    var utility = drawer.querySelector('.menu-drawer__utility-links');
    var temp = document.createElement('div');
    temp.innerHTML = buildHTML();
    var node = temp.firstElementChild;

    if (utility) {
      utility.appendChild(node);
    } else {
      drawer.appendChild(node);
    }
  }

  function init() {
    // First, opportunistic injection — drawer may already be in DOM
    inject();

    // Listen for drawer state changes
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t) return;
      if (t.closest('header-drawer summary, .header__icon--menu, .menu-drawer-container summary')) {
        // Defer one frame so the drawer is open before we inject
        requestAnimationFrame(function () {
          setTimeout(inject, 80);
        });
      }
    }, true);

    // Watch for drawer being attached/replaced
    var obs = new MutationObserver(function () { inject(); });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
